import React from "react";
import { Figure } from "../Figure";
import { CategoryChart, prefixValue, suffixValue } from "../processors";
import { FigureHorStackBarKpiProvider } from "../categoryChartQueryFns";
import { Paragraph } from "../Paragraph";
import { useCategoryContext } from "../Context";
import { CategoryTheme } from "../misc";
import { StackHorBarWithData } from "../LineWithAverageData";
import { getColor, getHighlightColors } from "../../themes";
import styles from "./FigureWithHorStackBar.module.scss";
import _ from "lodash";

interface FigureWithHorStackBarProps extends FigureHorStackBarKpiProvider {
    categoryChart: CategoryChart;
}

export const FigureWithHorStackBar: React.FC<FigureWithHorStackBarProps> = ({
    categoryChart,
    title,
    footer,
    figure,
    unit,
    graph,
    colorIndex
}) => {
    const { category } = useCategoryContext();

    if (!category) return null;

    const theme = category.theme as CategoryTheme;
    const figureValueNaN = _.isNaN(parseFloat(`${figure?.value}`));
    const figureValueZero = figure?.value === 0;

    return (
        <div className="row">
            {title != null && <Paragraph title={""} status={true} nid={0} text={title} className="col-12" />}
            <div
                className={`col ${
                    figure != null && graph != null && !figureValueNaN && !figureValueZero
                        ? "fix-width-col-400"
                        : figure != null && graph == null
                        ? "col-12"
                        : ""
                }`}
                style={{
                    display: figure != null ? undefined : "none"
                }}
            >
                {figure != null && (
                    <Figure
                        figureStyle={{
                            // getting colors for water provider
                            color:
                                colorIndex == null
                                    ? getColor(theme)
                                    : getHighlightColors(theme, colorIndex + 1)?.[colorIndex]
                        }}
                        className="w-100"
                        decimals={figure.decimals}
                        header={
                            !figure.header ? null : <Paragraph title={""} status={true} nid={0} text={figure.header} />
                        }
                        footer={
                            !figure.footer ? null : <Paragraph title={""} status={true} nid={0} text={figure.footer} />
                        }
                        value={figure.value}
                        prefix={prefixValue(figure.value, figure.unit)}
                        suffix={suffixValue(figure.value, figure.unit)}
                        unitInSuffix={figure?.unit}
                        unit={figure?.unit}
                        categoryChart={categoryChart}
                    />
                )}
            </div>

            {
                // sum is not a number, display empty
                figureValueNaN && graph?.emptyMessage != null ? (
                    <div className={`col-12 ${styles.chart}`}>
                        (
                        <Paragraph nid={1} status={true} title="" text={graph?.emptyMessage} />)
                    </div>
                ) : null
            }
            {graph && !figureValueNaN && (
                <div className={`col-12 ${styles.chart}`}>
                    <StackHorBarWithData
                        data={graph?.data}
                        header={graph.header}
                        footer={graph.footer}
                        theme={theme}
                        unit={unit}
                    />
                </div>
            )}
            {footer != null && <Paragraph title={""} status={true} nid={0} text={footer} className="col-12" />}
        </div>
    );
};
